import K18nUtils from '@k18n/k18n-utils';
import { lang } from './const';

// k18n
let k18n: any;
// 实例化K18n
export function createK18n(message) {
    if (k18n) return k18n;
    // 实例化K18n
    k18n = new K18nUtils({
        messages: [message],
        locale: lang,
    });
    return k18n;
}
export const $k18n = (params: string | { text?: string; key?: string; id?: string; desc?: string; params?: Record<string, any> }): string => {
    if (typeof params === 'string') {
        return k18n.getText({
            text: params,
        });
    }
    return k18n.getText(params);
};

// rtl语言
const rtlLang = ['ar', 'ur'];

export const $isRtl = () => {
    return rtlLang.includes(k18n.locale);
};
